export const TEMPLATE_LOADING = Symbol('TEMPLATE_LOADING')
export const TEMPLATE_AVAILABLE = Symbol('TEMPLATE_AVAILABLE')
export const TEMPLATE_UNAVAILABLE = Symbol('TEMPLATE_UNAVAILABLE')
